<div class="termos-page">
  <div class="curve-container">
    <img src="../../../assets/images/wave.svg" alt="Waves" />
  </div>
  <div>
    <img src="../../../assets/images/bio2Logo.png" class="logo-bio2" alt="Logo BIO2" />
  </div>
  <div class="termos-container">
    <span class="title-terms">
      <p><strong>Política de Privacidade e Autorização para Utilização e Partilha de Dados</strong></p>
    </span>
    <div class="termos-text">
      <p [innerHTML]="rgpdText1"></p>

      <div class="labs-list-rgpd">
        <mat-selection-list [(ngModel)]="selectedMainLabs">
          <!-- Formatted label above the options -->
          <p>
            <strong><u>Caso pretenda excluir algum laboratório desta partilha de dados</u></strong>,
            selecione abaixo
            <strong><u>APENAS os laboratórios que <em>NÃO AUTORIZA</em> a aceder</u></strong> aos dados de
            consumo:
          </p>

          <!-- Lab checkboxes -->
          @for (lab of mainLabs; track lab) {
            <mat-list-option [value]="lab.id">
              {{ lab.labName }}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>

      <div class="labs-autocomplete">
        <!-- Label + input in one row -->
        <div class="input-row">
          <label class="labs-label">OUTROS (indique quais): </label>
          <input class="rgpdOtherLabsInput" [formControl]="labCtrl" [matAutocomplete]="auto"
            placeholder="Digite para pesquisar..." />
          </div>

          <!-- Chips stacked below -->
          <mat-chip-listbox #chipList>
            @for (lab of selectedOtherLabs; track lab) {
              <mat-chip-row (removed)="removeLab(lab)">
                {{ lab.labName }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
            }
          </mat-chip-listbox>

          <!-- Autocomplete options -->
          <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete"
            (optionSelected)="selectLab($event)">
            @for (lab of filteredLabs | async; track lab) {
              <mat-option [value]="lab">
                {{ lab.labName }}
              </mat-option>
            }
          </mat-autocomplete>
        </div>

        <p [innerHTML]="rgpdText2"></p>
      </div>
      <div class="d-flex flex-row btns">
        <div class="btn-continue d-flex flex-row-reverse" (click)="setPreferences(false)">
          <img src="../../../assets/Icons/close-line.png" style="filter: brightness(0) invert(1);">
          Não autorizo
        </div>
        <div class="btn-continue d-flex flex-row-reverse" (click)="setPreferences(true)">
          <mat-icon svgIcon="arrow_right" iconPositionEnd></mat-icon>
          Sim, autorizo
        </div>
      </div>
    </div>
    <div class="fish-container">
      <img src="../../../assets/images/ellipse.svg" class="ellipse" alt="Ellipse" />
      <img src="../../../assets/images/fish.png" class="fish" alt="Fish" />
    </div>
    <img class="vector-5" src="../../../assets/images/Vector 5.png" alt="vetor-5" />
  </div>